import { formatNaira, maskNaira } from './lib/format';
import { cn } from './lib/cn';

export function NairaText({
  value,
  decimals = true,
  masked = false,
  className,
}: {
  value: number;
  decimals?: boolean;
  masked?: boolean;
  className?: string;
}) {
  return (
    <span className={cn('tabular-nums', className)}>
      {masked ? maskNaira() : formatNaira(value, { decimals })}
    </span>
  );
}
